export const FSCollections = {
  USERS: 'users',
  USER_INFO: 'info',
  USER_EMAIL_CHANGE_REQUESTS: 'email_change_request',
  ORGANIZATIONS: 'organizations',
  DIVISIONS: 'divisions',
  SCHEDULE_TEMPLATES: 'schedule_templates',
  SCHEDULES: 'schedules',
  NOTIFICATION_SUBSCRIPTIONS: 'notification_subscriptions',
  NOTIFICATION_ENTITIES: 'entities',
  NOTIFICATION_SUBSCRIBERS: 'subscribers',
  EXECUTIONS: 'executions',
  EXECUTION_RECORDS: 'execution_records',
  STATE: 'execution_states',
  STATE_TRANSITIONS: 'execution_state_transitions',
  TRIGGERS: 'triggers',
  EVENTS: 'events',
  SCHEDULE_OPTIONS: 'options',
  EVENT_TYPES: 'event_types',
  FORMS: 'forms',
  OPTION_LISTS: 'option_lists',
  OPTION_LIST_CHUNKS: 'chunks',
  LOCATION_ALERTS: 'location_alerts',
  DASHBOARDS: 'dashboards',
  CHARTS: 'charts',
  EVENT_CHARTS: 'events',
  DASHBOARD_EVENTS_TABLES: 'tables',
  DOCUMENT_REQUESTS: 'document_requests',
  LOCATIONS: 'locations',
  LOCATION_GROUPS: 'location_groups',
  INVITATIONS: 'invitations',
  USER_IMPORTS: 'user_imports',
  USER_IMPORT_MAPPINGS: 'user_import_mappings',
  USER_JOBS: 'user_jobs',
  FAKE_USERS: 'fake_users',
  COMPANIES: 'companies',
  WORK_SHIFTS: 'work_shifts',
  SHIFTS: 'shifts',
  WORK_JOURNEYS: 'work_journeys',
  WORK_JOURNEY_CONFIGS: 'work_journey_config',
  WORK_JOURNEY_MEMBERS: 'members',
  WORK_JOURNEY_SUPERVISORS: 'supervisors',
  TOTEMS: 'totems',
  ADDRESSES: 'addresses',
  CORPORATIONS: 'corporations',
  ACCOUNT_STATUS: 'account_status',
  POLICIES: 'policies',
  HOLIDAYS: 'holidays',
  EXCEPTIONS: 'exceptions',
  ATTENDANCE_EVENTS: 'attendance_events',
  ATTENDANCE_RECORDS: 'attendance_records',
  GROUPS: 'groups',
  AUDITS: 'audits',
  BAR_CHARTS: 'bar_charts',
  COUNT_CHARTS: 'count_charts',
  COUNTER_CHARTS: 'counter_charts',
  PIE_CHARTS: 'pie_charts',
  TABLES: 'tables',
  EMERGENCY_TYPES: 'emergency_types',
  EMERGENCY_ENROLLMENTS: 'emergency_enrollments',
  EMERGENCIES: 'emergencies',
  EMERGENCY_ASSIGNMENTS: 'emergency_assignments',
  EMERGENCY_INTEGRATIONS: 'emergency_integrations',
  EMERGENCY_TIMELINE_EVENTS: 'emergency_timeline_events',
  EMERGENCY_MONITORING_SESSIONS: 'emergency_monitoring_sessions',
  EMERGENCY_NOTIFICATION_RECEIPTS: 'emergency_notification_receipts',
  EMERGENCY_LOCATION_SAMPLES: 'emergency_location_samples',
  EMERGENCY_OUTBOX: 'emergency_outbox',
};
